import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card_body" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }


export default /*@__PURE__*/_defineComponent({
  __name: 'totalCard',
  props: {
    title1: {
        type: String,
        default: () => ''
    },
    title2: {
        type: String,
        default: () => ''
    },
    title3: {
        type: String,
        default: () => ''
    },
    value1: {
        type: [String, Number],
        default: () => 0
    },
    value2: {
        type: [String, Number],
        default: () => 0
    },
    value3: {
        type: [String, Number],
        default: () => 0
    },
    rightText1: {
        type: String,
        default: () => ''
    },
    rightText2: {
        type: String,
        default: () => ''
    },
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "12",
          class: "card_content"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_row, { class: "fieldRow" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  class: "field_row",
                  span: "24"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.title1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  class: "field_row_value",
                  span: "24"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(props.value1), 1),
                    (props.rightText2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.rightText2), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "12",
          class: "card_content"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_row, { class: "fieldRow" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  class: "field_row",
                  span: "24"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.title2), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  class: "field_row_value",
                  span: "24"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(props.value2), 1),
                    (props.rightText2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.rightText2), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})